import Description from '../../../../components/description/description.mobile';
import description from './description';

export default description(Description);
